<script>
  import AuthStore from "../Stores/AuthStore"
  import notify from "../../../../Script/notify"
  import { push } from "svelte-spa-router"
  import Navbar from "../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../Shared/footer.svelte"
  import { onMount } from "svelte"
  import ApplicationState from "../../../../Stores/applicationStates"

  onMount(() => {
    if (!$AuthStore.QRCode) {
      notify.info("You want to scan Qrcode, Complete you authentication process")
      push("/settings/integration/home")
    }
  })
</script>

<svelte:head>
  <title>2F Authentication</title>
</svelte:head>
<div class="relative min-h-screen w-full bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  <div class="px-6">
    <div class="mx-auto h-auto w-full max-w-[920px] select-none pb-40 pt-6">
      <div class="relative mt-6 flex min-h-[470px] flex-col justify-between rounded-md bg-white p-6 dark:bg-mdGray md:p-12">
        <div class="flex h-full w-full flex-col items-center gap-6 mobile:flex-row">
          <div class="h-full w-full space-y-3 mobile:w-1/2">
            <h1 class="lineHeight text-3xl font-extrabold dark:text-white mobile:text-5xl">
              Scan QR <br />
              Code
            </h1>
            <p class="w-full text-gray-200">Please scan the QR code using your linked authenticator app to link it securely. Protect your privacy during this process.</p>
          </div>

          <div class="flex h-full w-1/2 justify-end">
            <img src={$AuthStore.QRCode} alt="qrImage" class="rounded-md border-2 border-slate-600" />
          </div>
        </div>

        <div class="mt-6 flex items-center justify-center mobile:mt-0 mobile:justify-end">
          <button
            on:click={() => {
              $ApplicationState.secret = true
              push("/settings/integration/authenticator/verify")
            }}
            class="flex h-9 items-center justify-center rounded-md bg-green-500 px-8 text-sm font-medium text-white hover:bg-green-600 focus:outline-none active:bg-green-600 disabled:cursor-not-allowed disabled:bg-green-300"
          >
            <i class="fa-solid fa-check-double" />
            &nbsp;&nbsp;Yes, I have Scanned
          </button>
        </div>
      </div>
    </div>
  </div>

  <Footer />
</div>
